module.exports = __webpack_public_path__ + "img/pickup-total-pickup.dba1195a.svg";